import _ from "lodash"
import { connect } from "react-redux"
import { getOfferStartDateString } from "utilities/time"
import routeNames from "components/navigators/constants"
import View from "./view.web"
import { Store } from "utilities/Redux/store"
import { Navigation } from "components/types"
import { Offer } from "modules/Buyer/Offers/types"
import { Category } from "modules/Buyer/Categories/types"
import { getSellerProfileForOffer } from "modules/SellerProfiles/selectors"
import { bookingSelected } from "modules/Buyer/Offers/actions"
import { getCategoryById } from "modules/Buyer/Categories/selectors"
import { getOfferRequestByIdForBuyer } from "modules/Buyer/OfferRequests/selectors"
import { getAcceptedOfferForOfferRequest } from "modules/Buyer/Offers/selectors"
import { getLocaLizedName } from "utilities/Redux/normalizeHelpers"
import { getUnseenMessagesCountForChat } from "modules/ChatMessages/selectors"

interface OwnProps {
  id: string
  navigation: Navigation
}

const mapStateToProps = (state: Store, ownProps: OwnProps) => {
  const offerRequest = getOfferRequestByIdForBuyer(state, ownProps.id)
  const offer =
    offerRequest && getAcceptedOfferForOfferRequest(state, offerRequest)
  return {
    category: offerRequest && getCategoryById(state, offerRequest.category),
    offer,
    sellerProfile: offer && getSellerProfileForOffer(state, offer),
    unseenMessages: offer
      ? getUnseenMessagesCountForChat(state, offer.chat)
      : 0,
  }
}

const mapDispatchToProps = {
  bookingSelected,
}

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  dispatchProps: typeof mapDispatchToProps,
  ownProps: OwnProps,
) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onPress: (offer: Offer, category: Category) => {
    dispatchProps.bookingSelected(offer.id)

    ownProps.navigation.navigate(routeNames.BUYER.BOOKING_DETAILS, {
      name: `${getLocaLizedName(category.name)} ${getOfferStartDateString(
        offer,
      )}`,
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(View)
